export default __webpack_public_path__ + "static/Scout_Wild__Logo_Black-c9dcb07960108cdcb87697e58b5dd05c.png";